import { z } from "zod";
import {
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  PASSWORD_REQUIRED,
  PASSWORD_TOO_LONG,
  PASSWORD_TOO_SHORT,
  PASSWORDS_DO_NOT_MATCH,
} from "@/constants/forms";

export const RegisterSchema = z
  .object({
    email: z
      .string({
        invalid_type_error: EMAIL_INVALID,
        required_error: EMAIL_REQUIRED,
      })
      .email({ message: EMAIL_INVALID }),
    password: z
      .string()
      .min(6, PASSWORD_TOO_SHORT)
      .max(20, PASSWORD_TOO_LONG)
      .nonempty(PASSWORD_REQUIRED),
    confirmPassword: z
      .string()
      .min(6, PASSWORD_TOO_SHORT)
      .max(20, PASSWORD_TOO_LONG)
      .nonempty(PASSWORD_REQUIRED),
  })
  .superRefine((val, ctx) => {
    if (val.password !== val.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: PASSWORDS_DO_NOT_MATCH,
        path: ["confirmPassword"],
      });
    }
  });

export type RegisterType = z.infer<typeof RegisterSchema>;
